import { useEffect, useState } from "react";

// This hook is used to measure the time taken between two conditions
export const usePerformanceTimer =  (startCond: boolean, endCond: boolean) => {
  const [startTime, setStartTime] = useState(0)
  const [elapsedTime, setElapsedTime] = useState(0)

  useEffect(() => {
    if (startCond) {
      setStartTime(new Date().getTime());
    }
  }, [startCond]);

  useEffect(() => {
    if (endCond) {
      setElapsedTime(new Date().getTime() - startTime);
    }
  }, [endCond]);

  return [elapsedTime, startTime] as const;
}
